import { BackendURLContantas } from "@/constants/URLConstants";
import axios, { AxiosResponse } from "axios";
import { ContestResponseData } from "..";

export type LaravelValidationErrorResponse = {
  message: string;
  errors: Record<string, string[]>;
};

export type HasContestsFilter = "has" | "none";

export type ContestCategoryGetRequest = {
  page: number;
  query?: string;
  perPage?: 20 | 50 | 100;
  isActive?: boolean;
  sortBy?: "created_at" | "name" | "contests_count";
  sortOrder?: "asc" | "desc";
  hasContests?: HasContestsFilter;
};

export type ContestCategoryStoreRequest = {
  name: string;
  slug?: string;
  isActive: boolean;
};

export type ContestCategoryUpdateRequest = {
  id: number;
  name: string;
  slug?: string;
  isActive: boolean;
  sortOrder?: number;
};

export type ContestCategoriesResponse = {
  data: ContestCatetoryResponseData[];
  meta: {
    currentPage: number;
    lastPage: number;
    perPage: number;
    total: number;
  };
};

export type ContestCatetoryResponseData = {
  id: number;
  name: string;
  slug?: string;
  isActive: boolean;
  sortOrder: number;
  contestsCount: number;
  contests: ContestResponseData[];
};

export type ContestCategoryReponse = {
  data: ContestCatetoryResponseData;
};

export type ContestCategoryFindRequest = { id: number };

export type ContestCategoryDeleteResponse = { message: string };

export type MergeCategoriesPayload = {
  toCategoryId: number;
  fromCategoryIds: number[];
  mode: "move" | "copy";
  action: "keep" | "delete";
};

export type ContestCategoryIdData = {
  id: number;
  name: string;
  slug: string;
  isActive: boolean;
  sortOrder: number;
  contestsCount?: number;
  createdAt?: string;
  updatedAt?: string;
};

export type ContestCategoryIdResponseData = {
  data: ContestCategoryIdData[];
}

export const ContestCategoryAPI = {
  /**
   * 一覧取得（ページネーション対応）
   */
  get: async (request: ContestCategoryGetRequest): Promise<ContestCategoriesResponse> => {
    const { page, perPage = 20, isActive, query, sortBy, sortOrder, hasContests } = request;

    const sp = new URLSearchParams();
    sp.set("page", String(page));
    sp.set("per_page", String(perPage));

    if (query !== undefined && query.trim() !== "") sp.set("q", query.trim());
    if (isActive !== undefined) sp.set("is_active", isActive ? "1" : "0");
    if (sortBy) sp.set("sort_by", sortBy);
    if (sortOrder) sp.set("sort_order", sortOrder);
    if (hasContests) sp.set("has_contests", hasContests);

    const url = `${BackendURLContantas.CONTEST.CATEGORY.GET.PATH_NAME}?${sp.toString()}`;
    const { data } = await axios.get<unknown, AxiosResponse<ContestCategoriesResponse>>(url);
    return data;
  },

  /**
   * 詳細取得
   */
  find: async (payload: ContestCategoryFindRequest): Promise<{ data: ContestCatetoryResponseData }> => {
    const { data } = await axios.get<unknown, AxiosResponse<{ data: ContestCatetoryResponseData }>>(
      `${BackendURLContantas.CONTEST.CATEGORY.GET.PATH_NAME}/${payload.id}`
    );
    return data;
  },

  /**
   * 作成
   */
  post: async (payload: ContestCategoryStoreRequest): Promise<ContestCatetoryResponseData> => {
    const { data } = await axios.post<ContestCategoryStoreRequest, AxiosResponse<ContestCatetoryResponseData>>(
      `${BackendURLContantas.CONTEST.CATEGORY.POST.PATH_NAME}`,
      payload
    );
    return data;
  },

  /**
   * 更新
   */
  update: async (payload: ContestCategoryUpdateRequest): Promise<ContestCategoryReponse> => {
    const { data } = await axios.post<ContestCategoryUpdateRequest, AxiosResponse<ContestCategoryReponse>>(
      `${BackendURLContantas.CONTEST.CATEGORY.UPDATE.PATH_NAME}/${payload.id}`,
      payload
    );
    return data;
  },

  /**
   * 削除
   */
  delete: async (payload: ContestCategoryFindRequest): Promise<ContestCategoryDeleteResponse> => {
    const { data } = await axios.post<ContestCategoryFindRequest, AxiosResponse<ContestCategoryDeleteResponse>>(
      `${BackendURLContantas.CONTEST.CATEGORY.DELETE.PATH_NAME}/${payload.id}`,
      payload
    );
    return data;
  },

  /**
    * 統合
  */
  mergeCategories: async (payload: MergeCategoriesPayload): Promise<{ message: string }> => {
    const { data } = await axios.post<MergeCategoriesPayload, AxiosResponse<{ message: string }>>(
      `${BackendURLContantas.CONTEST.CATEGORY.MERGE.PATH_NAME}`,
      payload
    );
    return data;
  },
};